import { Controller } from "@hotwired/stimulus"
import * as echarts from 'echarts';

export default class extends Controller {
  connect() {
    // Any initialization can go here if needed
  }
}